<template>
    <div :class="['close-fab-button-body',IsMobile? '': 'pc-close-fab-button-body']">
        <VarIcon size="50" name="close-circle" class="close-fab-button" @click="onCLoseMe" />
    </div>
</template>
<script setup lang="tsx">
import { inject } from 'vue';

const IsMobile = inject("IsMobile");
const emit = defineEmits(["OnClose"]);
function onCLoseMe() {
    emit("OnClose");
}
</script>

<style lang="scss" scoped>
.close-fab-button-body {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 999;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    justify-content: center;
    // background-color: var(--tabs-indicator-background);
    background-color: white;
    color: var(--tab-active-color);
}

.pc-close-fab-button-body{

}
</style>